import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewDarVueltaCierre = () => import('./Index.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'dar_vuelta_cierre',
        name: 'Dar Vuelta Cierre',
        component: ViewDarVueltaCierre,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
